import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import { router } from './router';
import { useIntercom } from '@/shared/intercom/useIntercom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import i18n from '@shared/infrastructure/i18n/config';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

const IntercomBoot: React.FC = () => {
  useIntercom();
  return null;
};

const App: React.FC = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <IntercomBoot />
        <ErrorBoundary>
          <RouterProvider router={router} />
        </ErrorBoundary>
      </QueryClientProvider>
    </I18nextProvider>
  );
};

export default App;